import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreadorCatalogoComponent } from './components/creador-catalogo/creador-catalogo.component';
import { AdministrarCatalogosComponent } from './components/administrar-catalogos/administrar-catalogos.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';


@NgModule({
  declarations: [
    AdministrarCatalogosComponent,
    CreadorCatalogoComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    TableModule,
    DropdownModule,
    InputTextModule,
    MessageModule,
    PanelModule,
    DropdownModule,
    TooltipModule,
    InputSwitchModule
  ],
  exports: [
    AdministrarCatalogosComponent,
    CreadorCatalogoComponent
  ]
})
export class CatalogosModule { }
